import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import arrowBackIcon from "../../../assets/icons/arrow-back.svg";
import { changePasswordAction } from "../Actions/CommonActions";
import { swalErrorMessage } from "../../../Constant/swalMessage";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [spin, setSpin] = useState(false);
  const location = useLocation();
  const [errors, setErrors] = useState(false);
  const locSearch = new URLSearchParams(location.search);
  let token = locSearch.get("token");

  const [state, setState] = useState<any>({
    password: "",
    cpassword: "",
  });
  const { password, cpassword } = state;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    setSpin(true);
    if (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[!@#$%^&*()_+[\]{}|\\:;'"<>,.?/~`]/.test(password)
    ) {
      if (password === cpassword) {
        let obj = {
          emailToken: token,
          password: password,
        };

        const res: any = await dispatch(changePasswordAction(obj));
        if (res) {
          history.push("/");
        }
      } else {
        swalErrorMessage("Password didn't match");
      }
    } else {
      setErrors(true);
    }

    setSpin(false);
  };

  return (
    <Box className="main-container">
      <Typography className="font-28-700-grey">Reset Password</Typography>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Typography className="font-14-grey mb-1">Password</Typography>
        <TextField
          name="password"
          value={password}
          type="password"
          onChange={handleChange}
          variant="outlined"
          fullWidth
          placeholder="Enter your new password"
          sx={commonStyles.inputField}
        />
      </Box>
      <Box
        sx={{
          mb: 1,
        }}
      >
        <Typography className="font-14-grey mb-1">Confirm Password</Typography>
        <TextField
          name="cpassword"
          value={cpassword}
          onChange={handleChange}
          type={"password"}
          variant="outlined"
          fullWidth
          placeholder="Confirm your password"
          sx={commonStyles.inputField}
        />
      </Box>
      {errors && (
        <p style={{ color: "red" }}>
          Password must be at least 8 characters and must contain an uppercase,
          lowercase,numbers and special characters
        </p>
      )}
      <Button
        onClick={resetPassword}
        disabled={spin}
        variant="contained"
        sx={commonStyles.loginButton}
        fullWidth
      >
        Reset Password
      </Button>
      <Typography
        className="font-14-400-grey"
        sx={{
          textAlign: "center",
          mt: 3,
        }}
      >
        <Link
          to="/login"
          className="flex-xy-center"
          style={{
            textDecoration: "none",
            color: "#1A1D23",
          }}
        >
          <img
            src={arrowBackIcon}
            alt="arrow back"
            style={{ marginRight: 4 }}
          />
          Back to login
        </Link>
      </Typography>
    </Box>
  );
};

export default ResetPassword;
